<template>
    <div dir="rtl">
        <router-view name="navbar"></router-view>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: 'Index',
  mounted() {
    document.body.classList.add('rtl');
  },
  beforeUnmount() {
    document.body.classList.remove('rtl');
  },
  
}
</script>
<style lang="scss" >
    @import '../assets/scss/rtl.scss';
</style>